import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
    
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import ReplyIcon from '@material-ui/icons/Reply';
import { Tooltip, Grid, Typography, Checkbox, Paper, TextField, Button, IconButton } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';
import qrIcon from '../assets/qrIcon.png'

import { ThemeColors } from '../Theme'
import { Global, Constructors } from '../models/Global'
import { Service, ServiceParams } from '../models/Service'
import { Patron } from '../models/Patron';
import { LuxonDatePicker } from '../components/LuxonDateTimePicker'

import { RestComponent } from 'react-frontend-utils' 
import { OpenInNewTab } from '../App'
import { OptionalCost } from '../models/OptionalCost'
import { Resource } from '../models/Resource'

import { DeleteResourceHandler } from '../utils/DeleteResourceHandler';
import { AssignResourceHandler } from '../utils/AssignResourceHandler';

import { NewEditResourcePopover } from '../components/NewEditResourcePopover';
import { AssignResourcesPopover } from '../components/AssignResourcesPopover';
import { NotifyPatronPopover } from '../components/NotifyPatronPopover';

import { DateUtils, SummaryWidget, ManageTextField, ManageDecimalField, ManageNumericField, ManageTimeField, RichTextEditor, ListSelectPopover, OpenQRPopupWindow } from 'react-frontend-utils'
import { FormTemplate, FieldEditor, renderField } from 'form-builder';
import { DateConversions } from '../utils/DateConversions';

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const longDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export class ServicesPage extends RestComponent {
  
    styles = {
        paperLabel: {
            marginLeft: 5,
            color: 'gray',
            fontSize: '14pt',
        },
        paper: {
            padding: 10
        },
        roundedContainer: {
            border: '1px solid #CCCCCC', 
            borderRadius: '4px', 
            padding: 10,
            marginBottom: 20,
        },
        containerLabel: {
            fontSize: 14, 
            color: ThemeColors.darkGray, 
            marginLeft: 5
        },
        sectionLabel: {
            fontSize: 16, 
            color: 'black', 
            marginLeft: 5
        },
        viewLabel: {
            fontSize: 12, 
            color: 'gray', 
            marginLeft: 5
        },
        status: {
            margin: 'auto',
            alignContent: 'center',
            width: 100,
            float: 'right',
            textTransform: 'uppercase',
            padding: 5, 
            marginRight: 10,
            marginTop: 2,
            borderRadius: 2, 
            color: 'white', 
            textAlign: 'center'
        },
    };

    _defaultMaxBookingsPerDay = 10; // default value for maxBookingsPerDay

    _manageServiceId = null;        // from the Calendar page
    _currentDatabase = Global.getLastDatabase();

    _justCreatedServiceName = null;
    _originalAssignedResourcesFromService;

    _additionalCostHash =  window.crypto.randomUUID();

    _fieldInClipboard = null;
    _fieldEditor = React.createRef();

    constructor(props) {
        super(props);
        
        this.state.resources = [];                //The list of all Resources and Services
        this.state.services = [];                 //Just the list of Services
        this.state.selectedService = null;        //The currently selected Service
        this.state.status = null;                  //The status of the selected Service

        this.state.bookingEnabled = false;

        this.state.seasonBookingAutoEnableChecked = false;
        this.state.seasonBookingStartChecked = false;
        this.state.seasonBookingEndChecked = false;
        this.state.maxBookingsPerDayChecked = false;
        this.state.showPatronCount = false;

        this.state.usesSlotCalendar = false;

        this.state.createNewService = true;
        this.state.newEditResourcePopoverOpen = false;
        this.state.assignServiceResourcesPopoverOpen = false;
        this.state.availableServiceOwners = null;
        this.state.selectServiceOwnerPopoverOpen = false;

        this.state.notifyPatronPopoverOpen = false;

        this.state.fieldToEdit = null;
    }
    
    
   
    componentDidMount() {
        super.componentDidMount();
        window.addEventListener("databaseChangeEvent", this._databaseChanged);
        this._manageServiceId = this.props.manageServiceId;
        this._fetchAll();
    }

    // When the database changes, refetch the Services
    _databaseChanged = () => {
        if (Global.getLastDatabase() !== this._currentDatabase) {
            console.log("Database changed to " + Global.getLastDatabase() + ", refetching Services");
            this._fetchAll();
            this._currentDatabase = Global.getLastDatabase();
        }
    }
    
    //Fetch all Services
    _fetchAll = () => {
        this.setState({services: [], resources: [], selectedService: null, status: null, fieldToEdit: null});
   
        this.incrementBusy();
        this.secureJSONFetch("/bk/" + Global.getLastDatabase() + "/resources", {}, 
                            this._fetchResourcesCallback, this._fetchErrorCallback);         
    }
    
    // When the resources are fetched, filter them into just Services
    _fetchResourcesCallback = (response) => {
        this.decrementBusy();
        if (response) {
            const resources = response.map((json) => Constructors.resourcefromJson(json));
            const services = resources.filter((resource) => resource.type === "Service");

            const aggregate = {active: {count: 0, names: []}, waiting: {count: 0, names: []}, finished: {count: 0, names: []}, disabled: {count: 0, names: []}};
            services.forEach((service) => {
                switch(service.status()) {
                    case Service.Status.DISABLED:
                        aggregate.disabled.count++;
                        aggregate.disabled.names.push(service.name);
                        break;
                    case Service.Status.WAITING:
                        aggregate.waiting.count++;
                        aggregate.waiting.names.push(service.name);
                        break;
                    case Service.Status.FINISHED:
                        aggregate.finished.count++;
                        aggregate.finished.names.push(service.name);
                        break;
                    case Service.Status.ACCEPTING:
                        aggregate.active.count++;
                        aggregate.active.names.push(service.name);
                        break;
                    default:
                        console.error("Unknown status for Service: " + service.status());
                        break;
                }
            });

            if (this._manageServiceId) {
                const selectedService = services.find((service) => service.id === this._manageServiceId);
                if (selectedService)
                    setTimeout(() => this._selectService(null, selectedService));
            }
            else if (this._justCreatedServiceName) {
                const selectedService = services.find((service) => service.name === this._justCreatedServiceName);
                if (selectedService) {
                    setTimeout(() => this._selectService(null, selectedService));
                    this._justCreatedServiceName = null;
                }
            }

            this.setState({services: services, resources: resources, aggregate: aggregate});

        }
    }
   
    _fetchErrorCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
    }
  
   _getPatronLink = () => {
        return "patron/booking?database=" + this._currentDatabase + "&serviceid=" + this.state.selectedService.id;
    }

    _gotoPatronBooking = () => {
        OpenInNewTab(this._getPatronLink());
    }

    _openQr = () => {
        const link = "https://" + window.location.host + "/" + this._getPatronLink();
        OpenQRPopupWindow(this.state.selectedService.name, link);
    }
    
    _discard = () => {
        this._manageServiceId = null;
        this._justCreatedServiceName = null;
        this._fetchAll();
    }


    _prepForSave = (serviceParams) => {

        // Need to clear out these before posting to the server if not checked
        if (!this.state.seasonBookingAutoEnableChecked)
            serviceParams.seasonBookingAutoEnable = null;       // null this field if the checkbox is not checked

        if (!this.state.seasonBookingStartChecked)
            serviceParams.seasonBookingStart = null;       // null this field if the checkbox is not checked

        if (!this.state.seasonBookingEndChecked)
            serviceParams.seasonBookingEnd = null;       // null this field if the checkbox is not checked

        if (!this.state.maxBookingsPerDayChecked)
            serviceParams.maxBookingsPerDay = null;       // null this field if the checkbox is not checked
        else {
            if (!serviceParams.maxBookingsPerDay)
                serviceParams.maxBookingsPerDay = this._defaultMaxBookingsPerDay;  // set to default if not set
        }

        if (serviceParams.costPerPatron <= 0)
            serviceParams.maxPatronCount = 1;
    }

    //Post the current ServiceParams to modify to the server
    _save = () => {
        if (this.state.selectedService) {   
            
            // Check each of the business hours to make sure open is before close
            for (let i = 0; i < 7; i++) {
                if (this.state.selectedService.serviceParams.businessHours[i].enabled) {
                    const diff = DateUtils.diffTimeStrings(this.state.selectedService.serviceParams.businessHours[i].open, this.state.selectedService.serviceParams.businessHours[i].close);
                    const closeTime = DateUtils.minutesFromTimeString(this.state.selectedService.serviceParams.businessHours[i].close);
                    
                    // Special case: we allow the close time to be zero (midnight) to account for closing at the end of the day
                    if (diff < 0 && closeTime !== 0) {
                        this.showConfirmAlert("Error", "On " + longDays[i] + ", the closing time must be after the opening time", 'red');
                        return;
                    }
                }
            }

            //Make a copy of the selected ServiceParams to be posted back to the server.  Date fields are converted from luxon date objects to json date strings
            const serviceParamsToModify = ServiceParams.copyForPosting(this.state.selectedService.serviceParams);

            this._prepForSave(serviceParamsToModify);
                    
            this.incrementBusy();
            this.secureJSONFetch("/bk/services/" + this.state.selectedService.id + "/serviceParams", {method: 'POST', body: JSON.stringify(serviceParamsToModify)}, 
                                 this._saveCallback, this._fetchErrorCallback);
        }
    }
    
    
    _saveCallback = () => {
        this.showConfirmAlert("Success", "Service \"" + this.state.selectedService.name + "\" updated", 'green'); 
        this.decrementBusy();
        this._manageServiceId = this.state.selectedService.id;      // hold onto this for refresh
        this._fetchAll();
    }
  
 
    
    //Callback when a Service is selected from the available list, display the selected Service
    _selectService = (event, newValue) => { 

        console.log("Selected Service: " + newValue.name);
        const selectedService = newValue;

        //We need to hold the status in the state, since we're going to modify the selectedService object below which will affect status
        const status = selectedService.status();

        this.setState({selectedService: selectedService, status: status,
                       bookingEnabled: selectedService.serviceParams.enabled,
                       showPatronCount: selectedService.serviceParams.costPerPatron > 0,
                       seasonBookingAutoEnableChecked: selectedService.serviceParams.seasonBookingAutoEnable ? true : false,
                       seasonBookingStartChecked: selectedService.serviceParams.seasonBookingStart ? true : false,
                       seasonBookingEndChecked: selectedService.serviceParams.seasonBookingEnd ? true : false,
                       maxBookingsPerDayChecked: selectedService.serviceParams.maxBookingsPerDay ? true : false});

        // If these fields aren't set, LuxonDatePicker is going to initialize them to the current date. So if the user never changes them, we want our value
        // to be set to the current date as well.  If the check mark is never checked, we don't care, since we'll null them out before post
        const now = DateConversions.now(Global.getTimezone()).startOf('day');
        if (!selectedService.serviceParams.seasonBookingAutoEnable)
            selectedService.serviceParams.seasonBookingAutoEnable = now;
        if (!selectedService.serviceParams.seasonBookingStart)
            selectedService.serviceParams.seasonBookingStart = now;
        if (!selectedService.serviceParams.seasonBookingEnd)
            selectedService.serviceParams.seasonBookingEnd = now;

        // Set some default hours of operation if not set
        for (let i = 0; i < 7; i++) {
            if (!selectedService.serviceParams.businessHours[i])
                selectedService.serviceParams.businessHours[i] = {enabled: false, allDay: false};

            if (!selectedService.serviceParams.businessHours[i].open)
                selectedService.serviceParams.businessHours[i].open = DateUtils.parseTimeString("9:00 AM");
            if (!selectedService.serviceParams.businessHours[i].close)
                selectedService.serviceParams.businessHours[i].close = DateUtils.parseTimeString("5:00 PM");
        }

        this.setState({usesSlotCalendar: selectedService.usesSlotCalendar()});
    }
    

    _createNew = () => {
        this.setState({newEditResourcePopoverOpen: true, createNewService: true});
    }

    _editName = () => {
        this.setState({newEditResourcePopoverOpen: true, createNewService: false});
    }

    _delete = () => {
        // Call the common DeleteResourceHandler to handle the questions about deletion
        // When confirmed if there are future bookings deleted,  we open the NotifyPatronPopover to ask if we should notify patrons
        //      The callback from that popover will call confirmDelete to actually do the delete, with the email text if any
        // If no future bookings are affected, we just do the delete directly
        DeleteResourceHandler.deleteResource(this.state.selectedService, this, (resource, futureItemsDeleted) => {
            if (!futureItemsDeleted)
                this._confirmDeleteService(false);      // delete, no message
            else  
                this.setState({notifyPatronPopoverOpen: true, isDeletingService: true});   // open the notify popover
        });
    }

    _confirmDeleteService = (notify, msg) => {
        this.setState({notifyPatronPopoverOpen: false});
        DeleteResourceHandler.doDeleteResource(this.state.selectedService, this, notify, msg, () => {
            this._manageServiceId = null;
            this._justCreatedServiceName = null;
            this._fetchAll();
        });
    }


    // Create a new resource or service or edit an existing one, post it to the server, and refetch the resources
    _createEditNewResourceCallback = (type, name, category, description) => {
        this.setState({newEditResourcePopoverOpen: false});

        let service;
        if (this.state.createNewService) {
            const nextColor = Resource.getNextColor(this.state.services.length);
            service = Service.requestNew(name, category, description, nextColor);
        }
        else {
            service = this.state.selectedService;
            service.name = name;
            service.category = category;
            service.description = description;
        }
        this._postUpdatedService(service, true);
    }

    _postUpdatedService(service, andRefetch) {
        this.incrementBusy();

        this._prepForSave(service.serviceParams);

        const json = service.toJsonForPost();
        this.secureJSONFetch("/bk/resources", {method: 'POST', body: json},
                             () => {this._postServiceCallback(service, andRefetch)}, this._fetchErrorCallback);
    }


    _postServiceCallback = (service, andRefetch) => {
        this.decrementBusy(); 
        if (service.id)
            this._manageServiceId = service.id;      // hold onto this for refresh
        if (this.state.createNewService)
            this._justCreatedServiceName = service.name;

        if (andRefetch)
            this._fetchAll();
    }

    _selectAssignableResourcesForService = () => {
        this._originalAssignedResourcesFromService = [...this.state.selectedService.assignableResourceIds];  // copy this list, so we can compare later
        this.setState({assignServiceResourcesPopoverOpen: true});
    }

     // When the user selects the resources to assign to the service, close the popover and check if any resources were removed, to warn the user
    _serviceAssignedResources = () => {
    
        this.setState({assignServiceResourcesPopoverOpen: false});

        AssignResourceHandler.serviceAssignedResources(this.state.selectedService, this._originalAssignedResourcesFromService,
            this, null, this._confirmServiceAssignedResources);              
    }

    _confirmServiceAssignedResources = (service) => {
        this._postUpdatedService(service, false);
    }

    // Get the list of available users to select as the new service owner
    _selectServiceOwner = () => {
        // fetch available users
        this.incrementBusy();
        this.secureJSONFetch("/bk/" + Global.getLastDatabase() + "/services/users", {}, this._fetchServiceUsersCallback, this._fetchErrorCallback); 
    }

    _fetchServiceUsersCallback = (response) => {
        this.decrementBusy();
        //response is an array of user objects, with name and id fields
        this.setState({availableServiceOwners: response, selectServiceOwnerPopoverOpen: true});
    }

    // Callback from the selectServiceOwnerPopover when the user selects a new service owner, update the service owner - "owner" is the same object as returned from fetchServiceUsersCallback
    _updateServiceOwner = (owner) => {
        const service = this.state.selectedService;
        service.owner = owner ? owner.id : null;
        service.ownerName = owner ? owner.name : null;
        this.setState({selectServiceOwnerPopoverOpen: false});
        this._postUpdatedService(service, false);
    }
    


    
    //A field in the Service was changed, update the selected Service object with the new data
    _serviceParamsFieldChanged = (fieldName, userValue) => {
        this.state.selectedService.serviceParams[fieldName] = userValue;  
        if (fieldName === "costPerPatron")
            this.setState({showPatronCount: userValue > 0});
        
        this.setState({usesSlotCalendar: this.state.selectedService.usesSlotCalendar()});
    }

    _onDateParseError = (title, message) => {
        this.showConfirmAlert(title, message, 'red');
    }
    
    _tooltipForCount = (nameList, title) => {
        
        const spliceList = [...nameList];  //shallow copy
        const matrix = [];
        while (spliceList.length) 
            matrix.push(spliceList.splice(0,3));
        
        return  <div>
                    <Typography variant='caption' style={{borderBottom: '1px solid white'}}>{title}</Typography>
                    <table>
                        <tbody>
                        {matrix.map((row, index) => <tr key={index}>
                                                <td style={{fontSize: 13, paddingRight: 10}}>{row[0]}</td>
                                                <td style={{fontSize: 13, paddingRight: 10}}>{row[1]}</td>
                                                <td style={{fontSize: 13}}>{row[2]}</td>
                                           </tr>
                                   )}
                        </tbody>
                    </table>
                </div>;
    }

    _patronAvailabilityBoxChecked = (field, event) => {
        this.state[field + "Checked"] = event.target.checked;
        this.forceUpdate();
    }
    

    _dayHoursOfOperation = (day) => {

        const sp = this.state.selectedService.serviceParams;
        const isUs = DateConversions.isUSDateFormat();
        const initialOpenTimeString = isUs ? DateUtils.toFriendlyTimeString(sp.businessHours[day].open) : sp.businessHours[day].open;
        const initialCloseTimeString = isUs ? DateUtils.toFriendlyTimeString(sp.businessHours[day].close) : sp.businessHours[day].close;

        const onFieldChange = (json, timeStr) => {
            if (json === "open")
                sp.businessHours[day].open = DateUtils.parseTimeString(timeStr);  // convert to 24 hour time, if needed
            else
                sp.businessHours[day].close = DateUtils.parseTimeString(timeStr);  // convert to 24 hour time, if needed
        };

        return (
            <div key={day} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginTop: 5, marginBottom: 5, height: 50}}>
                <Checkbox checked={sp.businessHours[day].enabled} color='primary'
                        onChange={(event) => {sp.businessHours[day].enabled = event.target.checked; this.forceUpdate();}}/>  


                <Typography variant='body1' style={{marginRight: 20, width: 60}} align='flex-start'>{days[day]}</Typography>
                {sp.businessHours[day].enabled ? 
                    <Fragment>
                        <Checkbox checked={sp.businessHours[day].allDay} color='primary'
                                  onChange={(event) => {sp.businessHours[day].allDay = event.target.checked; this.forceUpdate();}}/>
                        <Typography variant='body1' style={{marginRight: 30, width: 90}} align='flex-start'>All Day</Typography>

                        {!sp.businessHours[day].allDay ?
                            <Fragment>
                                <ManageTimeField label="Opens" 
                                                style={{maxWidth: 200, marginRight: 20}}
                                                json="open"
                                                autoAccept={true}
                                                clockColor={ThemeColors.clockColor} 
                                                twelveHour={isUs}
                                                initialValue={initialOpenTimeString} 
                                                onFieldChange={onFieldChange} 
                                                onParseError={this._onDateParseError}/> 
                                <ManageTimeField label="Closes" 
                                                style={{maxWidth: 200}}
                                                json="close"
                                                autoAccept={true}
                                                clockColor={ThemeColors.clockColor} 
                                                twelveHour={isUs}
                                                initialValue={initialCloseTimeString} 
                                                onFieldChange={onFieldChange} 
                                                onParseError={this._onDateParseError}/> 
                            </Fragment> 
                            : null
                        }
                    </Fragment>
                    : null
                }
            </div>
        );
    }


    _addAdditionalCostItem = () => {
        const oc = OptionalCost.initNew();  
        this.state.selectedService.serviceParams.additionalCosts.push(oc);
        this.forceUpdate();
    }

    _additionalCostItem = (item, index) => {

        const onFieldChange = (json, val) => {
            if (json === "name")
                item.name = val;
            else if (json === "maxQuantity")
                item.maxQuantity = parseInt(val);
            else if (json === "cost")
                item.cost = parseFloat(val);
            else
                console.log("Error: Unknown field name " + json);
            this.forceUpdate();
        };

        const removeItem = () => {
            this.state.selectedService.serviceParams.additionalCosts.splice(index, 1);
            this._additionalCostHash =  window.crypto.randomUUID();  // force a new hash
            this.forceUpdate();
        }

        // Hash is needed so React will re-render the list when an item is removed, since these are ManagedFields we want to destroy them and recreate them

        return (
            <div key={index +  this._additionalCostHash} style={{display: 'flex', alignItems: 'center', justifyContent: 'left', gap: 10, marginTop: 10, marginBottom: 5}}>
                
                <ManageTextField label="Item Name"
                                initialValue={item.name}
                                json="name"  
                                tooltip="Name for the item the Patron may purchase"
                                autoAccept={true}
                                onFieldChange={onFieldChange}/>

                <div style={{minWidth: 300}}>
                    <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                    label={"Cost (" + this.state.selectedService.isoCurrency + ")"} minValue={0}
                                    decimalPlaces={2}
                                    json="cost"
                                    initialValue={item.cost}
                                    commitTimeout={10}
                                    autoAccept={true}
                                    onFieldChange={onFieldChange}
                                    changedBackgroundColor='white'/> 
                </div>

                <div style={{minWidth: 220}}>
                    <ManageNumericField fullWidth={false} hasInfinity={false} justify='left' 
                                    tooltip={"Maximum number of this item that can be purchased"}
                                    label="Max Quantity" minValue={1}
                                    json="maxQuantity"
                                    autoAccept={true}
                                    commitTimeout={10}
                                    initialValue={item.maxQuantity}
                                    onFieldChange={onFieldChange}
                                    changedBackgroundColor='white'/> 
                </div>
                
                <Tooltip title="Remove item">
                    <IconButton onClick={removeItem} >
                        <ClearOutlinedIcon fontSize="large" style={{color: ThemeColors.darkRed}}/>
                    </IconButton>
                 </Tooltip>
            </div>
        );
    }


    _rekey = () => {
        this.showConfirmAlert("Regenerate Subscription Link", "Are you sure you want to regenerate the Subscription Link? Any subscribers will need to re-subscribe with the new link.",
                                'black',
                                "Cancel", 
                                this._confirmRekey,
                                "Re-key",
                                'red');
    }

    _confirmRekey = () => {
        this.incrementBusy();
        this.secureJSONFetch("/bk/services/" + this.state.selectedService.id + "/rekey", {method: 'POST'},
                                this._rekeyCallback, this._fetchErrorCallback);
    }

    _rekeyCallback = (response) => {
        this.decrementBusy();
        this.showConfirmAlert("Success", "Service \"" + this.state.selectedService.name + "\" subscription link re-keyed", 'green'); 
        this._fetchAll();
    }


    _isEditorOpen = () => {
        return this.state.fieldToEdit != null;
    }

    _fieldPropertyEdit = (field) => {
        
        //When first created the FieldEditor component receives the field prop, however since it makes use of uncontrolled components, if the field is changed
        //we must call the fieldPropertyEdit() on its reference to update the field explicity.
        if (this._fieldEditor.current)
            this._fieldEditor.current.fieldPropertyEdit(field);

        console.log("Editing properties for field: " + field.name);
        this.setState({fieldToEdit: field});        
    }

    
    _insertFieldFromClipboard = (parent) => {
        
        if (!this._fieldInClipboard)
            return;  //nothing on clipboard
        
        const insertedField = FormTemplate.insertField(this.state.selectedService.serviceParams.fieldTree, parent, this._fieldInClipboard);
        
        if (this._isEditorOpen())
            this._fieldPropertyEdit(insertedField); //start editing the newly inserted field

        this.forceUpdate();
    }

    _fieldsAdded = (fields) => {
        if (fields.length > 0)
            this._fieldPropertyEdit(fields[0]); //start editing the first newly inserted field
    }
    
    _copyField = (field) => {
        this._fieldInClipboard = FormTemplate.copyField(field);
        console.log(this._fieldInClipboard.name + " is now on the Clipboard");
        this.forceUpdate();
    }

    _fieldMoved = (field) => {
        if (this._isEditorOpen())
            this._fieldPropertyEdit(field); //re-edit the field being moved
    }


    //Remove the field from the tree and place on Clipboard
    _cutField = (field) => {
        
        if (this.state.fieldToEdit && this.state.fieldToEdit.name === field.name) {
            this.setState({fieldToEdit: null});  //field is being deleted, stop editing it
        }
        
        const removedField = FormTemplate.removeField(this.state.selectedService.serviceParams.fieldTree, field);

        if (removedField) {
            this._fieldInClipboard = removedField;  //place on clipboard
            console.log(this._fieldInClipboard.name + " is now on the Clipboard");
            this.forceUpdate();
        }
        else {
            console.warn("Field \"" + field.name + "\" not found in Template, cannot remove");
        }
    }

    _removeField = (field) => {
        
        if (this.state.fieldToEdit && this.state.fieldToEdit.name === field.name) {
            this.setState({fieldToEdit: null});  //field is being deleted, stop editing it
        }
        
        FormTemplate.removeField(this.state.selectedService.serviceParams.fieldTree, field);
        this.forceUpdate();
    }
    
    
    //Edit the value of a field
    _formFieldValueChanged = (field, newValue) => {
        console.log("Field \"" + field.name + "\" changing to " + newValue);
        this.forceUpdate();
    } 

    //Called when editing the field value, and an error occurs
    _fieldInputError = (field, error) => {
        this.showConfirmAlert("Error for Field \"" + field + "\"", error, 'red');
    }

    //This function must return an array of available fields, each item in the array having a label, icon, and a callback function.  The callback function should
    //(a) create a new field and (b) call the insertFunction to insert it into the Template 
    _getAvailableFields = (insertFunc) => {
        const service = this.state.selectedService;
        if (!service)
            return [];
        return Patron.getAvailableFields(service.serviceParams.fieldTree, insertFunc, service.isoCurrency);        
    }
    
    


    //------------------------------- RENDER ----------------------------------------------
    
    render() {
       
        const buttonStyle = (activeColor, disabled) => {     
            let color = disabled ? 'lightGray' : activeColor;
            return {borderColor: color, color: color, textAlign: 'center'};
        };
       

        const service = this.state.selectedService;
        const assignableResourceIds = service ? service.assignableResourceIds : [];

        const assignedResources = this.state.resources.filter((res) => assignableResourceIds.includes(res.id));
        const assignedResourceNames = assignedResources.map((res) => res.name);
        const assignedResourcesTooltip = <div>
                                            <Typography variant='caption'>Assign Resources to Service</Typography>
                                            <br/>
                                            {assignedResourceNames ? 
                                                <div style={{marginTop: 10}}>
                                                    <Typography variant='caption' style={{fontWeight: 'bold'}}>Current Assigned Resources:</Typography>
                                                    <ul style={{paddingLeft: 15, marginTop: 0}}>
                                                        {assignedResourceNames.map((name, index) => <li key={index} style={{fontSize: 13}}>{name}</li>)}
                                                    </ul>
                                                </div>
                                                : <div>No Resources Assigned</div>
                                            }
                                        </div>;                                     

        const showService = service !== null;
        const canSave = showService && service.canManage();

        const canCreateNew = !showService && Global.isResourceManager();
        const canEditBasicInfo = showService &&  Global.isResourceManager();
            
        const sp = service && service.serviceParams ? service.serviceParams : null;

        const currency = service ? service.isoCurrency : "???";

        const calendarTypeText = this.state.usesSlotCalendar ? "Patron's time selection view will be a calendar grid, with unavailable times greyed out. The patron can click and drag slots to book." : 
                                                               "Patron's time selection view will be a calendar of buttons showing available time slots; pressing the button selects the time.";

        const bookingDuration = sp ? sp.incrementsMinutes : 0;
        const bookingDurationText = bookingDuration < 90 ? bookingDuration + " min" : (Math.floor(bookingDuration / 60) + " hr, " + (bookingDuration % 60) + " min");

        let resourcesString = "";
        let resourcesCount = 0;
        if (service) {
            resourcesCount = service.assignableResourceIds.length;
            if (resourcesCount === 0)
                resourcesString = "No Resources Assigned";
            else
                resourcesString = resourcesCount + " Resource" + (resourcesCount === 1 ? " Available" : "s Available");
        }

         const formRenderParams = {forPatron: false, 
                                  forTemplate: true, 
                                  canEdit: true, 
                                  showFieldNames: false,
                                  onChange: this._formFieldValueChanged, 
                                  cutField: this._cutField,
                                  copyField: this._copyField,
                                  removeField: this._removeField, 
                                  clipboardField: this._fieldInClipboard,
                                  insertFieldFromClipboard: this._insertFieldFromClipboard,
                                  getAvailableFields: this._getAvailableFields,
                                  onFieldPropertyEdit: this._fieldPropertyEdit,
                                  onFieldsAdded: this._fieldsAdded,
                                  fieldMoved: this._fieldMoved,
                                  fieldBeingEdited: this.state.fieldToEdit ? this.state.fieldToEdit.name : null,
                                  onError: this._fieldInputError};

        return (                        
             <Fragment>
                {this.getConfirmAlertComponent()}

                <NewEditResourcePopover isOpen={this.state.newEditResourcePopoverOpen} isNew={this.state.createNewService} 
                                        resource={service} newType="Service"
                                        cancelCallback={() => this.setState({newEditResourcePopoverOpen: false})} okCallback={this._createEditNewResourceCallback}/>
                
                <AssignResourcesPopover isOpen={this.state.assignServiceResourcesPopoverOpen} service={service} resources={this.state.resources}
                                         onCancel={() => this.setState({assignServiceResourcesPopoverOpen: false})} onUpdate={this._serviceAssignedResources}/>
                
                {service ?
                    <ListSelectPopover isOpen={this.state.selectServiceOwnerPopoverOpen} title={"Select New Service Owner for " + service.name}  
                                        items={this.state.availableServiceOwners}
                                        okCallback={(selected) => this._updateServiceOwner(selected)}
                                        noneCallback={() => this._updateServiceOwner(null)}
                                        cancelCallback={() => this.setState({selectServiceOwnerPopoverOpen: false})}/>      
                    : null
                }     

                <NotifyPatronPopover isOpen={this.state.notifyPatronPopoverOpen} resource={this.state.selectedService} isDeletingResource={this.state.isDeletingService}
                                    cancelCallback={() => this.setState({notifyPatronPopoverOpen: false})} 
                                    sendEmailCallback={(msg) => this._confirmDeleteService(true, msg)} 
                                    suppressEmailCallback={() => this._confirmDeleteService(false, null)}/>
                
                <Grid container direction="row" spacing={2} style={{padding: 10, marginBottom: 20}}>
                    <Grid item sm={3} xs={6}>
                        <SummaryWidget label="Accepting" 
                                value={this.state.aggregate ? this.state.aggregate.active.count : "..."}
                                tooltip={this._tooltipForCount(this.state.aggregate ? this.state.aggregate.active.names : [], "Services that are currently accepting Bookings")}
                                tooltipWidth='100%'
                                borderColor={Service.Status.ACCEPTING.color}/>
                    </Grid>                  
                    <Grid item sm={3} xs={6}>
                        <SummaryWidget label="Waiting" 
                                value={this.state.aggregate ? this.state.aggregate.waiting.count : "..."}
                                tooltip={this._tooltipForCount(this.state.aggregate ? this.state.aggregate.waiting.names : [], "Services that have not started accepting Bookings")}
                                tooltipWidth='100%'
                                borderColor={Service.Status.WAITING.color}/>
                    </Grid>         
                    <Grid item sm={3} xs={6}>
                        <SummaryWidget label="Finished" 
                                value={this.state.aggregate ? this.state.aggregate.finished.count : "..."}
                                tooltip={this._tooltipForCount(this.state.aggregate ? this.state.aggregate.finished.names : [], "Services no longer accepting Bookings")}
                                tooltipWidth='100%'
                                borderColor={Service.Status.FINISHED.color}/>
                    </Grid>
                    <Grid item sm={3} xs={6}>
                       <SummaryWidget label="Disabled" 
                                value={this.state.aggregate ? this.state.aggregate.disabled.count : "..."}
                                tooltip={this._tooltipForCount(this.state.aggregate ? this.state.aggregate.disabled.names : [], "Services manually disabled")}
                                tooltipWidth='100%'
                                borderColor={Service.Status.DISABLED.color}/>
                    </Grid>
                </Grid>
                
                
  
                <div style={{display: 'flex', gap: 20, marginLeft: 10, marginRight: 10, justifyContent: 'left', alignItems: 'center'}}>
                    <Autocomplete
                        size='small'
                        disabled={showService}
                        style={{width: 400}}
                        value={service}
                        onChange={this._selectService}
                        options={this.state.services}
                        blurOnSelect
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => <TextField {...params} label="Service" variant="outlined" InputLabelProps={{ shrink: true }} />}
                    />            
                
                    <Tooltip title="Save Changes and Refresh">
                        <Button disabled={!canSave}  size='small' style={buttonStyle('green', !canSave)} 
                                onClick={this._save} variant="outlined" component="label">
                            Save
                        </Button>
                    </Tooltip>                    
                    <Tooltip title="Discard Changes and Clear">
                        <Button disabled={!showService}  size='small' style={buttonStyle('black', !showService)} 
                                onClick={this._discard} variant="outlined" component="label">
                            Discard
                        </Button>
                    </Tooltip>
                    <Tooltip title="Create New Service">
                        <Button disabled={!canCreateNew}  size='small' style={buttonStyle('orange', !canCreateNew)} 
                                onClick={this._createNew} variant="outlined" component="label">
                            New
                        </Button>
                    </Tooltip>
                    <Button disabled={!canEditBasicInfo} size='small' style={buttonStyle('red', !canEditBasicInfo)}
                            onClick={this._delete} variant="outlined" component="label">
                        Delete
                    </Button>
                     
                    {this.state.isBusy ? this.getBusyComponent('right', {marginLeft: 20}, 30) : null}

                </div>

                {service ? 
                    <div style={{display: 'flex', gap: 20, marginTop: 40, marginLeft: 10, marginRight: 10, justifyContent: 'left', alignItems: 'center'}}>

                        <Tooltip title="Edit the Service's Name, Category, and Description">
                            <Button disabled={!canEditBasicInfo} size='small' style={buttonStyle('black', !canEditBasicInfo)}
                                    onClick={this._editName} variant="outlined" component="label">
                                Edit Basic Info
                            </Button>
                        </Tooltip>
                        <Tooltip title={assignedResourcesTooltip}>
                            <Button disabled={!canEditBasicInfo} size='small' onClick={this._selectAssignableResourcesForService} variant="outlined" 
                                    style={{color: canEditBasicInfo ? (assignableResourceIds.length > 0 ? 'blue': 'orange') : 'lightGray'}} component="label">
                                    {"Assign Resources (" + assignableResourceIds.length + ")"}
                            </Button>
                        </Tooltip>
                        {Global.isResourceManager() ?
                            <Tooltip title="Select new Service owner">
                                <Button size='small' variant='outlined' style={{color: service.ownerName ? 'black' : 'red'}} onClick={this._selectServiceOwner}>
                                    {"Service Owner: " + (service.ownerName ? service.ownerName : "Unassigned")}
                                </Button>
                            </Tooltip>
                            :
                            <Typography variant="body2" align='center' style={{marginBottom: 5, color: service.ownerName ? 'black' : 'red'}}>
                                {"Service Owner: " + (service.ownerName ? service.ownerName : "Unassigned")}
                            </Typography>  
                        }
                        <Tooltip title="Get a QR Code image for the Patron signup Page">
                            <Button size='small' style={{...buttonStyle('black', false), marginLeft: 'auto'}} 
                                    onClick={this._openQr} variant="outlined" component="label"
                                    startIcon={<img src={qrIcon} alt="QR Icon" style={{ width: 20, height: 20, paddingRight: 5 }}/>}>
                                QR Code
                            </Button>
                        </Tooltip>
                        <Tooltip title="Go to the Page the Patron will visit to book the Service (opens in new window)">
                            <Button size='small' style={buttonStyle('black')} 
                                    onClick={this._gotoPatronBooking} variant="outlined" component="label"
                                    startIcon={<ReplyIcon style={{transform: 'scaleX(-1)'}}/>}>
                                Go to Patron Booking Page
                            </Button>
                        </Tooltip>
                    </div>
                    : null
                }
                
                <div style={{marginTop: 15}}/>
                
                {sp ?

                    <Fragment>
        
                        <Paper style={this.styles.paper}>   

                            <Tooltip title={this.state.status.tooltip}>
                                <div style={{...this.styles.status, backgroundColor: this.state.status.color}}>
                                        {this.state.status.label}
                                </div>
                            </Tooltip>
                            
                            <div style={{display: 'flex', alignItems: 'top', justifyContent: 'left', gap: 40, marginBottom: 20}}>
                                <Typography style={this.styles.paperLabel} variant="h6">{"Service Settings for \"" + service.name + "\""}</Typography> 
                            </div>

                            <Grid container spacing={2}>

                                <Grid item xs={12} lg={6}>
                                    
                                    <Typography variant="body2" style={this.styles.sectionLabel}>Service Availability</Typography>            
                                    <div style={this.styles.roundedContainer}>
                                        <Typography variant='caption' align='right' style={{display: 'flex', justifyContent: 'right', color: 'gray', fontStyle: 'italic', marginLeft: 'auto'}}>{"Timezone: " + Global.getTimezone()}</Typography>                        
                                        
                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginBottom: 10}}>
                                            <Tooltip title="When unchecked, Patrons cannot book the Service (but you can manually create Bookings)">
                                                <Checkbox defaultChecked={sp.enabled} color='primary'
                                                        onChange={(event) => { sp.enabled = event.target.checked; this.setState({bookingEnabled: event.target.checked}); }}/>       
                                            </Tooltip>                           
                                            <Typography variant='body1' align='left' style={{color: this.state.bookingEnabled ? 'green' : 'red', width: 200}}>Enable Patrons to Signup</Typography>                        
                                        </div>

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: 5, marginBottom: 5, height: 50}}>
                                            <Tooltip title="When checked, the Service is closed to Patrons before this date. Otherwise, Patrons can access the Booking Portal anytime">
                                                <Checkbox checked={this.state.seasonBookingAutoEnableChecked} color='primary'
                                                          onChange={(event) => this._patronAvailabilityBoxChecked("seasonBookingAutoEnable", event)}/>                                  
                                            </Tooltip>
                                            <Typography variant='body1' style={{width: 200}} align='left'>Service Opens After</Typography>
                                            <div style={{maxWidth: 400, display: this.state.seasonBookingAutoEnableChecked ? 'block' : 'none'}}>
                                                <LuxonDatePicker label='Open' timezone={Global.getTimezone()} 
                                                                initialDate={sp.seasonBookingAutoEnable}
                                                                onDateChange={(date) => sp.seasonBookingAutoEnable = date} onParseError={this._onDateParseError} /> 
                                            </div>
                                        </div>

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: 5, marginBottom: 5, height: 50}}>
                                            <Tooltip title="When checked, this is the earliest time that can be booked.">
                                                <Checkbox checked={this.state.seasonBookingStartChecked} color='primary'
                                                          onChange={(event) => this._patronAvailabilityBoxChecked("seasonBookingStart", event)}/>                                  
                                            </Tooltip>  
                                            <Typography variant='body1' align='left' style={{width: 200}}>First available Booking</Typography>
                                            <div style={{maxWidth: 400, display: this.state.seasonBookingStartChecked ? 'block' : 'none'}}>
                                                <LuxonDatePicker label='Start' timezone={Global.getTimezone()} 
                                                                initialDate={sp.seasonBookingStart}
                                                                onDateChange={(date) => sp.seasonBookingStart = date} onParseError={this._onDateParseError} /> 
                                            </div>
                                        </div>

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: 5, marginBottom: 5, height: 50}}>
                                            <Tooltip title="When checked, this is the latest time bookings can be scheduled for (they may not start after this time)">
                                                <Checkbox checked={this.state.seasonBookingEndChecked} color='primary'
                                                          onChange={(event) => this._patronAvailabilityBoxChecked("seasonBookingEnd", event)}/> 
                                            </Tooltip>                                 
                                            <Typography variant='body1' align='left' style={{width: 200}}>Last Booking Before</Typography>
                                            <div style={{maxWidth: 400, display: this.state.seasonBookingEndChecked ? 'block' : 'none'}}>
                                                <LuxonDatePicker label='End' timezone={Global.getTimezone()} 
                                                                initialDate={sp.seasonBookingEnd}
                                                                onDateChange={(date) => sp.seasonBookingEnd = date} onParseError={this._onDateParseError} /> 
                                            </div>
                                        </div>

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: 5, marginBottom: 5, height: 50}}>
                                            <Tooltip title="When checked, only Members can book the Service (Members must supply a barcode or Membership ID when booking and Membership must not be suspended or expired)">
                                                <Checkbox defaultChecked={sp.requiresMembership} color='primary'
                                                          onChange={(event) => sp.requiresMembership = event.target.checked}/> 
                                            </Tooltip>                                 
                                            <Typography variant='body1' align='left' style={{width: 200}}>Requires Membership</Typography>
                                        </div>

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: 5, marginBottom: 5, height: 50}}>
                                            <Tooltip title="When checked, allows a maximum number of Bookings per day, otherwise unlimited">
                                                <Checkbox checked={this.state.maxBookingsPerDayChecked} color='primary'
                                                          onChange={(event) => {this._patronAvailabilityBoxChecked("maxBookingsPerDay", event)}}/>                                 
                                            </Tooltip>  
                                            <Typography variant='body1' align='left' style={{width: 200}}>Limit Daily Bookings</Typography>
                                            <div style={{maxWidth: 400, display: this.state.maxBookingsPerDayChecked ? 'block' : 'none'}}>
                                                <ManageNumericField hasInfinity={false} justify='left' 
                                                                    minValue={1}
                                                                    label="Max Bookings Per Day"
                                                                    autoAccept={true}
                                                                    commitTimeout={10}
                                                                    json="maxBookingsPerDay"
                                                                    initialValue={sp.maxBookingsPerDay ? sp.maxBookingsPerDay : this._defaultMaxBookingsPerDay} 
                                                                    onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/> 
                                            </div>
                                        </div>

                                    </div>
                                </Grid>


                                <Grid item xs={12} lg={6}>

                                    <Typography variant="body2" style={this.styles.sectionLabel}>Service Hours of Operation</Typography>
                                    <div style={this.styles.roundedContainer}>

                                        {this._dayHoursOfOperation(0)}
                                        {this._dayHoursOfOperation(1)}
                                        {this._dayHoursOfOperation(2)}
                                        {this._dayHoursOfOperation(3)}
                                        {this._dayHoursOfOperation(4)}
                                        {this._dayHoursOfOperation(5)}
                                        {this._dayHoursOfOperation(6)}

                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="body2" style={this.styles.sectionLabel}>Booking Instructions</Typography>
                                    <div style={this.styles.roundedContainer}>
                                        <RichTextEditor draftContent={sp.about}     
                                                editing={true}  
                                                onChange={ (draftJson) => {
                                                    this._serviceParamsFieldChanged("about", draftJson);
                                                }}/>
                                    </div>
                                </Grid>  

                                <Grid item xs={12} lg={7}>

                                    <Typography variant="body2" style={this.styles.sectionLabel}>Booking Interval Times and Scheduling</Typography>
                                        <div style={this.styles.roundedContainer}>
                                            <Typography variant='h6' align='center' style={{marginTop: 2, color: ThemeColors.appBarBackground}}>{"Booking Duration: " + bookingDurationText}</Typography>                        

                                            <div style={{display: 'flex', flexDirection: 'row', gap: 40, marginTop: 10}}>
                                                <div style={{display: 'flex', flexDirection: 'column', gap: 10, width: 340}}>

                                                    <div>
                                                        <Autocomplete size='small'
                                                                        style={{width: 300, marginTop: 5, marginLeft: 15, marginBottom: 5}}
                                                                        value={sp.incrementsMinutes}
                                                                        onChange={(event, newValue) => { this._serviceParamsFieldChanged("incrementsMinutes", newValue) }}
                                                                        options={ServiceParams.IncrementsMinutes}
                                                                        getOptionLabel={(option) => (option < 120 ? (option + " minutes") : (option / 60) + " hours")}
                                                                        blurOnSelect
                                                                        disableClearable
                                                                        renderInput={(params) => <TextField {...params} label="Interval Length" variant="outlined" InputLabelProps={{ shrink: true }} />}
                                                                    /> 
                                                        <Typography variant='body2' align='left' style={{fontStyle: 'italic', color: 'gray', marginLeft: 15, marginBottom: 20}}>{calendarTypeText}</Typography>
                                                    </div>
 

                                                    <ManageNumericField fullWidth={false} hasInfinity={false} justify='left' 
                                                                        tooltip="The minimum number of intervals that must be requested for a single Booking"
                                                                        label="Min Intervals" minValue={1}
                                                                        json="minIncrements"
                                                                        commitTimeout={10}
                                                                        autoAccept={true}
                                                                        initialValue={sp.minIncrements} 
                                                                        onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>     

                                                    <ManageNumericField fullWidth={false} hasInfinity={false} justify='left' 
                                                                        tooltip="The maximum number of intervals that can be requested for a single Booking"
                                                                        label="Max Intervals" minValue={1}
                                                                        json="maxIncrements"
                                                                        commitTimeout={10}
                                                                        autoAccept={true}
                                                                        initialValue={sp.maxIncrements} 
                                                                        onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>     

                                                    <ManageNumericField hasInfinity={false} justify='left' 
                                                                        tooltip="Amount of time to block before a Booking to prevent other bookings from being scheduled too close to this Booking's start time."
                                                                        label="Pre Booking Buffer (minutes)" minValue={0} increment={5}
                                                                        json="preBookingBufferMinutes"
                                                                        commitTimeout={10}
                                                                        autoAccept={true}
                                                                        initialValue={sp.preBookingBufferMinutes} 
                                                                        onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>  
                                                    
                                                    <ManageNumericField hasInfinity={false} justify='left' 
                                                                        tooltip="Amount of time to block after a Booking to prevent other bookings from being scheduled too close to this Booking's end time."
                                                                        label="Post Booking Buffer (minutes)" minValue={0} increment={5}
                                                                        json="postBookingBufferMinutes"
                                                                        commitTimeout={10}
                                                                        autoAccept={true}
                                                                        initialValue={sp.postBookingBufferMinutes} 
                                                                        onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>  
                                                    
                                                    <Autocomplete size='small'
                                                                        tooltip="The minimum time required between the current time and the start of the Booking"
                                                                        style={{width: 300, marginTop: 10, marginLeft: 15, marginBottom: 5}}
                                                                        value={sp.bookingLeadTimeMinutes}
                                                                        onChange={(event, newValue) => { this._serviceParamsFieldChanged("bookingLeadTimeMinutes", newValue) }}
                                                                        options={ServiceParams.LeadTimeMinutes}
                                                                        getOptionLabel={ (option) => ServiceParams.getLeadTimeLabel(option)}
                                                                        blurOnSelect
                                                                        disableClearable
                                                                        renderInput={(params) => <TextField {...params} label="Requried Lead Time before Booking" variant="outlined" InputLabelProps={{ shrink: true }} />}
                                                                    /> 

                                                </div>

                                                <div>

                                                    {!this.state.usesSlotCalendar ?
                                                        <Autocomplete size='small'
                                                                        tooltip="Align the start of the Booking to the nearest time interval"
                                                                        style={{width: 300, marginTop: 5, marginBottom: 20}}
                                                                        value={sp.schedulingInterval}
                                                                        onChange={(event, newValue) => { sp.schedulingInterval = newValue; }}
                                                                        options={ServiceParams.SchedulingIntervals}
                                                                        getOptionLabel={(option) => {
                                                                            switch (option) {
                                                                                case 15: return "On the quarter hour";
                                                                                case 30: return "On the half hour";
                                                                                case 60: return "Top of the hour";
                                                                                default: return "Unknown";
                                                                            }
                                                                        }}
                                                                        blurOnSelect
                                                                        disableClearable
                                                                        renderInput={(params) => <TextField {...params} label="Align Bookings" variant="outlined" InputLabelProps={{ shrink: true }} />}
                                                                    />  
                                                    : null}

                                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                                        <Tooltip title="If the service allows multiple bookings at the same time, check this box (typically used when there are several Resources available).">
                                                            <Checkbox defaultChecked={sp.allowOverlap} color='primary'
                                                                    onChange={(event) => sp.allowOverlap = event.target.checked}/> 
                                                        </Tooltip> 
                                                        <Typography variant='body1' align='left'>Allow Overlapping Bookings</Typography>                        
                                                    </div>  

                                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: !this.state.usesSlotCalendar ? 200 : 265}}>
                                                        <Tooltip title="When checked, the pre and post buffers also block the Resource assigned to a Booking, as well as its Service.">
                                                            <Checkbox defaultChecked={sp.bufferBlocksResource} color='primary'
                                                                    onChange={(event) => sp.bufferBlocksResource = event.target.checked}/> 
                                                        </Tooltip> 
                                                        <Typography variant='body1' align='left'>Pre/Post Buffers Block Resource</Typography>                        
                                                    </div>    

                                                </div>
                                            </div>
                                        </div>


                                </Grid> 

                                <Grid item xs={12} lg={5}>

                                    <Typography variant="body2" style={this.styles.sectionLabel}>Resources</Typography>
                                    <div style={this.styles.roundedContainer}>

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                            <Tooltip title="When checked, the Service must have at least one Resource that is available during the booking time (ignored if the Service has are no assigned Resources)">
                                                <Checkbox defaultChecked={sp.requireAvailableResource} color='primary'
                                                        onChange={(event) => sp.requireAvailableResource = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography variant='body1' align='left'>Require Available Resource</Typography>                        
                                        </div>   

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                            <Tooltip title="When checked, the Patron can select among available Resources. Otherwise, one will be randomly assigned.">
                                                <Checkbox defaultChecked={sp.allowPatronToSelectResource} color='primary'
                                                        onChange={(event) => sp.allowPatronToSelectResource = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography variant='body1' align='left'>Allow Patron to Select Resource</Typography>                        
                                        </div>  

                                        <Typography variant='body2' align='center' style={{color: resourcesCount === 0 ? 'red' : "blue", fontStyle: 'italic', marginTop: 10}}>{resourcesString}</Typography>

                                    </div> 
                                </Grid>
                                
                                <Grid item xs={12} lg={7}>

                                    <Typography variant="body2" style={this.styles.sectionLabel}>Fees</Typography>
                                    <div style={this.styles.roundedContainer}>

                                        <Typography variant='caption' align='right' style={{display: 'flex', justifyContent: 'right', color: 'gray', fontStyle: 'italic', marginLeft: 'auto'}}>All costs are calculated and added to the total in the order below.</Typography>                        
    

                                        <div style={{width: 340, marginBottom: 0}}>

                                            <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                                tooltip="A fixed cost for the entire Booking"
                                                                label={"Base Cost (" + currency + ")"} minValue={0}
                                                                decimalPlaces={2}
                                                                commitTimeout={10}
                                                                autoAccept={true}
                                                                json="baseCost"
                                                                initialValue={sp.baseCost} 
                                                                onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>  
                                        </div>

                                        <div style={{width: 340, marginBottom: 10}}>

                                            <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                                tooltip="Cost per each interval of time booked."
                                                                label={"Cost per Interval (" + currency + ")"} minValue={0}
                                                                decimalPlaces={2}
                                                                commitTimeout={10}
                                                                autoAccept={true}
                                                                json="costPerIncrement"
                                                                initialValue={sp.costPerIncrement} 
                                                                onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>  
                                        </div>
                                        <div style={{display: 'flex', flexDirection: 'row', width: 720}}>

                                            <div style={{width: 340}}>
                                                <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                                    tooltip={"Cost per patron for the entire Booking"}
                                                                    label={"Cost per patron (" + currency + ")"} minValue={0}
                                                                    decimalPlaces={2}
                                                                    commitTimeout={10}
                                                                    autoAccept={true}
                                                                    json="costPerPatron"
                                                                    initialValue={sp.costPerPatron} 
                                                                    onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/> 
                                            </div>

                                            {this.state.showPatronCount > 0 ?
                                                <ManageNumericField fullWidth={false} hasInfinity={false} justify='left' 
                                                                    tooltip="Maximum number of Patrons who can attend the Booking"
                                                                    label="Max Patrons per Booking" 
                                                                    minValue={1}
                                                                    autoAccept={true}
                                                                    commitTimeout={10}
                                                                    json="maxPatronCount"
                                                                    initialValue={sp.maxPatronCount} 
                                                                    onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>  
                                                : null
                                            }
                                        </div>       

                                        {sp.additionalCosts.map((item, index) => this._additionalCostItem(item, index))}

                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
                                            <Button size='small' variant='outlined' style={{color: ThemeColors.addColor}} onClick={this._addAdditionalCostItem} color='primary'>Add Cost Item</Button>
                                        </div>

                                        <div style={{display: 'flex', flexDirection: 'column', marginTop: 10, gap: 10, maxWidth: 300}}>

                                            <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                                tooltip="Add a Service fee as a percentage to the total cost calculated above"
                                                                label={"Service Fee %"} minValue={0}
                                                                decimalPlaces={1}
                                                                commitTimeout={10}
                                                                autoAccept={true}
                                                                json="serviceFeePercent"
                                                                initialValue={sp.serviceFeePercent} 
                                                                onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>  

                                            <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                                tooltip="Add a fixed Service fee to the total cost calculated above"
                                                                label={"Fixed Service Fee (" + currency + ")"}  minValue={0}
                                                                decimalPlaces={2}
                                                                commitTimeout={10}
                                                                autoAccept={true}
                                                                json="serviceFeeFixed"
                                                                initialValue={sp.serviceFeeFixed} 
                                                                onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/> 
                                        </div>   

                                        <div style={{display: 'flex', alignItems: 'center', marginLeft: 5, marginTop: 10, justifyContent: 'start'}}>
                                            <Tooltip title="Add an additional Service fee that matches your AGS payment processing fee, effectively passing our fee to you on to your Patrons. Only available if your Marketplace operates in USD.
                                                     This fee is applied all other fees above. The fee is not applied if the order total is zero.">         
                               
                                                <Checkbox defaultChecked={sp.addAGSServiceFee} color='primary'
                                                            onChange={(event) => service.serviceParams.addAGSServiceFee = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography variant='body1' align='left'>Add Matching AGS Service Fee</Typography>                        
                                        </div> 

                                        <div style={{display: 'flex', alignItems: 'center', marginLeft: 5, marginTop: 10, justifyContent: 'start'}}>
                                            <Tooltip title="Allow patron to optionally pay with cash or other method outside of the Booking portal. The Booking will indicate the amount due from the Patron.">
                               
                                                <Checkbox defaultChecked={sp.allowCashPayment} color='primary'
                                                            onChange={(event) => service.serviceParams.allowCashPayment = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography style={{minWidth: 180}} variant='body1' align='left'>Allow Other Payment</Typography>                        
                                            <Typography variant='caption' style={{marginLeft: 15, fontStyle: 'italic', color: 'gray'}} align='left'>If patron elects to pay a different way you must process this payment outside the portal. Indicate payment methods in your terms and conditions.</Typography>                        
                                        </div>  

                                       

                                    </div>
                                </Grid>

                                <Grid item xs={12} lg={5}>

                                    <Typography variant="body2" style={this.styles.sectionLabel}>Changes by Patron</Typography>
                                    <div style={this.styles.roundedContainer}>
                                       
                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                            <Tooltip title="When checked, the Patron can cancel the Booking themselves">
                                                <Checkbox defaultChecked={sp.allowCancellation} color='primary'
                                                        onChange={(event) => sp.allowCancellation = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography variant='body1' align='left'>Allow Cancellation</Typography>                        
                                        </div>  
                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                            <Tooltip title="When checked, the Patron can reschedule the Booking themselves">
                                                <Checkbox defaultChecked={sp.allowRescheduling} color='primary'
                                                        onChange={(event) => sp.allowRescheduling = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography variant='body1' align='left'>Allow Rescheduling</Typography>                        
                                        </div>  
                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                            <Tooltip title="When checked, if the patron cancells their Booking, a refund is automatically issued. Otherwise, it must be manually issued.">
                                                <Checkbox defaultChecked={sp.autoRefund} color='primary'
                                                        onChange={(event) => sp.autoRefund = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography variant='body1' align='left'>Auto Refund Fee on Cancellation</Typography>                        
                                        </div>  
                                        <Typography variant='body1' align='left' style={{marginLeft: 15, marginTop: 10}}>Minimum Time for Patron to Reschedule/Cancel (hours)</Typography>                        
                                        <div style={{maxWidth: 300}}>
                                            <ManageNumericField fullWidth={false} hasInfinity={false} justify='left' 
                                                                tooltip="The minimum number of hours before the Booking starts when the Patron can reschedule or cancel, if allowed"
                                                                minValue={0}
                                                                json="minHoursBeforeChange"
                                                                commitTimeout={10}
                                                                autoAccept={true}
                                                                initialValue={sp.minHoursBeforeChange} 
                                                                onFieldChange={this._serviceParamsFieldChanged} changedBackgroundColor='white'/>  
                                        </div>
                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                            <Tooltip title="When checked, the Service owner is emailed when a Patron initially confirms, changes, or cancels a Booking">
                                                <Checkbox defaultChecked={sp.emailOnPatronBooking} color='primary'
                                                        onChange={(event) => sp.emailOnPatronBooking = event.target.checked}/>  
                                            </Tooltip>
                                            <Typography variant='body1' align='left'>Email Service Owner on Booking Activity</Typography>                        
                                        </div>  

                                    </div>
                                </Grid>

                                <Grid item xs={12}>

                                    <Typography variant="body2" style={this.styles.sectionLabel}>Additional Patron Questions</Typography>
                                    <div style={{...this.styles.roundedContainer, display: 'flex', minHeight: 500}}>
                                            
                                        {sp.fieldTree.children.length === 0 ?
                                            <Typography variant='body1' align='right' style={{width: '100%', marginTop: 100, color: 'gray', fontStyle: 'italic'}}>
                                                Add patron questions using the + button
                                            </Typography>
                                            :
                                            null
                                        }
        
                                        <div style={{width: this.state.fieldToEdit !== null ? '70%' : '100%'}}>
                                            {sp.fieldTree ? renderField(sp.fieldTree, 0, formRenderParams) : null}
                                        </div>
                                            
                                        
                                        <div style={{width: this.state.fieldToEdit !== null ? '30%' : '0%', marginLeft: 20}}>
                                            {this.state.fieldToEdit !== null ?
                                                <FieldEditor ref={this._fieldEditor} 
                                                                stayInContainer={true}
                                                                fieldToEdit={this.state.fieldToEdit}
                                                                fieldTree={sp.fieldTree}
                                                                hideFieldName={true}
                                                                hideHiddenSelect={true}
                                                                hideModifiableSelect={true}
                                                                hideDocumentMergeSelect={true}
                                                                hideUrlSettableSelect={true}
                                                                disableHiddenLogic={true}
                                                                hideWebhookSelect={true}
                                                                fieldWasEdited={() => this.forceUpdate()}
                                                                onClose ={() => this.setState({fieldToEdit: null})} />
                                                : 
                                                null
                                            }
                                        </div>
                                                
                                    </div>

                                </Grid>

                                <Grid item xs={12}>

                                    <Typography variant="body2" style={this.styles.sectionLabel}>Terms & Conditions (patron must click checkbox to agree before booking)</Typography>
                                    <div style={this.styles.roundedContainer}>

                                        <RichTextEditor draftContent={sp.termsAndConditions}     
                                                editing={true}  
                                                onChange={ (draftJson) => {
                                                    this._serviceParamsFieldChanged("termsAndConditions", draftJson);
                                                }}/>
                                    </div>
                                </Grid>     

                            </Grid>

 
                        </Paper>

                        {showService ?
                            <Paper style={{...this.styles.paper, marginTop: 30}}>   
                                    
                                <Typography style={{...this.styles.paperLabel, marginBottom: 20}} variant="h6">iCal Subscription</Typography> 
                                
                                <Typography variant='body2' style={{marginTop: 10, color: 'gray', fontStyle: 'italic'}}>Use this URL to subscribe to the Service's Booking Calendar in your own calendar application. Only share this link with people authorized to view all patron Bookings on this Service.</Typography>
                                <Typography variant='body2' style={{marginTop: 10, color: 'blue'}}>{"https://booking.accessgrantedsystems.net/ical/service/" + service.subscriptionFeedKey}</Typography>

                                <Button size='small' style={{marginTop: 20}} onClick={this._rekey} variant="outlined" component="label">
                                    Re-key Subscription URL
                                </Button>
                            </Paper>
                            : null
                        }

                    </Fragment>                
                    : null
                }
                    
            </Fragment>
        );
        
    }
}



export default withCookies(withRouter(ServicesPage));




